import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorZonaService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorZonaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorZonaService_Factory() { return new EventMantenedorZonaService(); }, token: EventMantenedorZonaService, providedIn: "root" });
